import api from "../../util/backend";
import baseUrl from "../../util/baseUrl";
import axios from "axios";
import {
  table,
  banner,
  setting,
  board,
  tableAndHorizal
} from "../../../mockup/outside";
import { banner2, content } from "../../../mockup/inside";
import router from "../../router";

export default {
  ///getTable//////
  async getTable({ commit, state }, payload) {
    try {
      // console.log("id_user nana", state.id_user);
      const response = await axios.get(
        `${baseUrl}/getTable?path=${payload}&id_user=${state.id_user}`
      );
      console.log("table", response.data);
      console.log("table", JSON.stringify(response.data.data.data[0]));
      commit("GET_TABLE", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },

  ///getTabComponent////
  async getTab({ commit }, payload) {
    try {
      console.log(payload);
      const response = await axios.get(
        `${baseUrl.baseurl()}/getTab?path=${payload}`
      );
      for (const index of response.data.data) {
        if (index.isActive) {
          let active = index;
          console.log(active);
          commit("GET_TAB_ACTIVE", active);
        }
      }
      // console.log(response.data);
      commit("GET_TAB", response.data.data);
    } catch (error) {
      console.error(error);
    }
  },

  ///getRenderDetail
  async getRenderDetail({ commit }, payload) {
    console.log("payload", payload);
    try {
      // const response = await axios.get(
      //   `${baseUrl}/getDetailContent?path=${payload.path}&detail=${payload.detail}&id_user=${payload.id_user}`
      // );
      console.log("detail", tableAndHorizal.data.componentDetail);
      // commit("GET_RENDER_DETAIL",tableAndHorizal.data.data)
      commit("GET_RENDER_DETAIL", tableAndHorizal.data.componentDetail);
      commit("GET_DETAIL_DATA", tableAndHorizal.data.data);
    } catch (error) {
      console.error(error);
    }
    // lodash.each(getDetailContent, a => {
    //   // console.log(a);
    //   if (a.slug === `${payload}`) {
    //     console.log("aaa", a);
    //     commit("GET_RENDER_DETAIL", a.componentDetail);
    //     commit("GET_DETAIL_DATA", a.data);
    //   }
    //   // a.slug === payload ? commit("GET_RENDER_DETAIL", a.componentDetail),log : null;
    // });
  },

  ///change tab component active
  async changeTabActive({ commit, state }, payload) {
    const tab = state.tab;
    const pointer = state.pointer;
    for await (const index of tab) {
      if (payload.index.path == index.path) {
        index.isActive = true;
        console.log("index active", index);
        let query = index.path.split("?");
        console.log(query[1]);
        let table;
        switch (pointer) {
          case "course":
            table = await api.getCourseTable(
              payload.id,
              query[1] || index.path
            );
            break;
          case "video":
            table = await api.getVideoTable(payload.id, query[1] || index.path);
            break;
          case "banner":
            table = await api.getBannerTable(query[1] || index.path);
            console.log("hello", table);
            break;

          default:
            break;
        }
        await commit("GET_TAB", table.data.data.table.tab);
        await commit("GET_PAGE", table.data.data);
        commit("GET_TAB_ACTIVE", index);
      } else {
        index.isActive = false;
      }
    }

    // console.log("tab", tab);
    // commit("GET_TAB", tab);
  },
  async getPage({ commit }, payload) {
    // const response = await axios.get(
    //     `xxx`
    //   );
    console.log("state.tab", table.table.tab);
    commit("GET_PAGE", table);
    commit("GET_TAB", table.table.tab);
    // commit("GET_TAB", );
  },
  async getPage_2({ commit }, payload) {
    // const response = await axios.get(
    //     `xxx`
    //   );
    console.log("state.tab", table.table.tab);
    commit("GET_PAGE", banner);
    commit("GET_TAB", banner.table.tab);
    // commit("GET_TAB", );
  },
  async getPage_3({ commit }, payload) {
    // const response = await axios.get(
    //     `xxx`
    //   );
    // console.log("state.tab", table.table.tab);
    commit("GET_PAGE", setting);
    commit("GET_TAB", banner.table.tab);
    // commit("GET_TAB", );
  },

  async get_language({ commit }, payload) {
    // console.log(banner2)
    commit("GET_LANGUAGE", banner2.language);
  },

  async switch_language({ commit, state }, payload) {
    commit("SWITCH_LANGUAGE", payload);
  },

  async get_banner({ commit }, payload) {
    // console.log("banner_2",banner2);

    const x = banner2.language.filter(a => {
      return a.value == true;
    });

    // console.log(banner2)
    for (let [key, value] of Object.entries(banner2)) {
      // console.log(key,x[0].name);
      //console.log("value",value)
      if (x[0].name == key) {
        commit("CHANGE_LANGUAGE", value);
      } else {
      }
    }
    commit("CHANGE_BANNER_DATE", {
      startDate: banner2.startDate,
      endDate: banner2.endDate
    });
    commit("CHANGE_PUBLISH", banner2.isPublish);
  },

  async get_content({ commit }) {
    commit("GET_CONTENT", content);
  },

  async change_content({ commit }, payload) {
    // console.log("payload in action",payload)
    commit("CHANGE_CONTENT", payload);
  },
  ////////////////////////////////////////////

  async page_banner({ commit }, payload) {
    // console.log("page_banner",payload)
    commit("PAGE_BANNER", banner2);
  },

  async get_bannertype({ commit }) {
    // console.log("get_bannertype",banner2.type)
    commit("GET_BANNERTYPE", banner2.type);
  },

  async push_content({ commit, getters }, payload) {
    const content = this.getters["general/content"];
    for (let [key, value] of Object.entries(content)) {
      // console.log(key,value)
      const item = {
        sub_content_img: null,
        text: null
      };

      if (payload === key) {
        let subcontent = value;
        subcontent.sub_content.push(item);
        // console.log("subcontent",subcontent)
        value = subcontent;

        commit("PUSH_CONTENT", content);
      }
    }
  },

  async delete_content({ commit, getters }, payload) {
    const content = this.getters["general/content"];
    for (let [key, value] of Object.entries(content)) {
      if (payload.lang === key) {
        let subcontent = value;
        subcontent.sub_content.splice(payload.index, 1);
        // console.log("subcontent",subcontent)
        value = subcontent;

        commit("PUSH_CONTENT", content);
      }
      console.log("deleted", payload);
    }
  },

  delete_img({ commit }, payload) {
    for (let [key, value] of Object.entries(banner2)) {
      console.log(key, value);
      if (payload === key) {
        // console.log(key,value)
        console.log("check");
        value.img = null;
      }
      //console.log("value",value)
    }
  },

  // async push_isShow ({commit},payload){
  //   console.log("???",payload.sub_content)
  //   const showImg = {isShow:false}

  //     for (let [key ,value] of Object.entries(payload.sub_content)){
  //       console.log("log",key,value)
  //       console.log("length",payload.sub_content.length)
  //       if (!payload.sub_content[key].isShow){
  //       let newValue = value
  //       newValue.push(showImg)

  //       value = newValue
  //       // commit ("PUSH_ISSHOW",payload)
  //       }
  //     }

  //     console.log("new payload",payload)
  // }

  async clear_page({ commit }) {
    try {
      await commit("CLEAR_PAGE");
    } catch (error) {
      console.log(error);
    }
  },

  // async login({ commit }, data) {
  //   const { email, password } = data;
  //   try {
  //     api.login(email, password)
  //     .then(async (res)=>{
  //       localStorage.setItem('token', res.data.token)
  //       localStorage.setItem('refresh_token', res.data.RefreshToken)
  //       await commit("COLLECT_TOKEN", { token: res.data.token, refresh_token: res.data.RefreshToken});
  //       await commit("GET_ADMIN_INFO", res.data.data )
  //     })
  //     .catch((err)=>{
  //       console.log(err);
  //       return err
  //     })
  //   } catch (error) {
  //     console.log(error);
  //   }
  // },

  async logout({ commit }) {
    try {
      api.logout();
      await commit("COLLECT_TOKEN", { token: null, refresh_token: null });
      await commit("GET_ADMIN_INFO", null);
      await commit("GET_TAB", null);
      await commit("GET_PAGE", null);
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      router.push({ path: "/pages/login" });
    } catch (error) {
      console.log(error);
    }
  },

  async getAllCurriculum({ commit }) {
    try {
      let table = await api.getAllCurriculum();
      //console.log(table.data.data);
      commit("GET_TAB", table.data.data.table.tab);
      await commit("GET_PAGE", table.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async getcurriculumtype({ commit }) {
    try {
      let table = await api.getCurriculumtype();
      //console.log(table.data.data);
      commit("GET_TAB", table.data.data.table.tab);
      await commit("GET_PAGE", table.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async getCurriculumDetail({ commit }, payload) {
    try {
      //console.log("payload",payload);
      let table = await api.getCourseTable(payload);
      console.log(table.data.data.tab);
      await commit("GET_TAB", table.data.data.table.tab);
      await commit("GET_PAGE", table.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async push_activePage({ commit }, payload) {
    try {
      await commit("PUSH_ACTIVEPAGE", payload);
    } catch (error) {
      console.log(error);
    }
  },

  async getCourseDetail({ commit }, payload) {
    try {
      console.log(payload);
      let table = await api.getVideoTable(payload);
      console.log("Course table", table.data.data.table.tab);
      await commit("GET_TAB", table.data.data.table.tab);
      await commit("GET_PAGE", table.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async getOrganization({ commit }) {
    try {
      let table = await api.getorganization();
      console.log("Organization Table", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
      await commit("GET_PAGE", table.data.data);
    } catch (error) {
      console.log(error);
    }
  },

  async get_organization_choice({ commit }) {
    try {
      let options = [];
      let choices = await api.organization_choice();
      //console.log("Choice>>>>", choices.data.data);
      for (let choice of choices.data.data) {
        options.push({
          name: choice.name,
          code: choice.organization_id
        });
      }
      console.log("option", options);
      await commit("GET_CHOICE", options);
    } catch (error) {
      console.log(error);
    }
  },

  async get_curriculumtype_choice({ commit }, payload) {
    try {
      let options = [];
      let choices = await api.curriculumtype_choice();
      //console.log(">>>>", choices.data.data);
      for (let choice of choices.data.data) {
        if (choice.type == payload) {
          options.push({
            name: choice.title,
            code: choice.category_curriculum_id,
            type: choice.type
          });
        }
      }
      console.log("option", options);
      await commit("GET_CHOICE", options);
    } catch (error) {
      console.log(error);
    }
  },

  async getAll_Lecturer({ commit }) {
    try {
      let options = [];
      let choices = await api.getAllLecturer();
      //console.log(">>>>", choices.data.data);
      for (let choice of choices.data.data) {
        options.push({
          name: choice.first_name + "  " + choice.last_name,
          code: choice.lecturer_id
        });
      }
      console.log("option", options);
      await commit("GET_CHOICE", options);
    } catch (error) {
      console.log(error);
    }
  },

  async getRenderEdit({ commit }, payload) {
    try {
      switch (payload.slug) {
        case "curriculum":
          console.log("check curriculum");
          await api
            .getcurriculum_byid(payload.id)
            .then(res => {
              commit("Get_Editdata", res.data.data);
            })
            .then(() => {
              router.push(`/curriculum/edit/${payload.id}`);
            });
          break;
        case "curriculumtype":
          console.log("check curriculumType", payload.id);
          await api
            .getcurriculumType_byid(payload.id)
            .then(res => {
              commit("Get_Editdata", res.data.data);
            })
            .then(() => {
              router.push(`/curriculumType/edit/${payload.id}`);
            });
          break;
        case "lecturer":
          console.log("check lecturer");
          await api
            .getlecturer_byid(payload.id)
            .then(res => {
              commit("Get_Editdata", res.data.data);
            })
            .then(() => {
              router.push(`lecturer/edit/${payload.id}`);
            });
          break;
        case "organization":
          console.log("organization", payload.id);
          await api
            .getorganization_byid(payload.id)
            .then(res => {
              commit("Get_Editdata", res.data.data);
            })
            .then(() => {
              router.push(`/organization/edit/${payload.id}`);
            });
          break;
        case "banner":
          console.log("check banner");
          await api
            .getbanner_byid(payload.id)
            .then(res => {
              commit("Get_Editdata", res.data.banner);
            })
            .then(() => {
              router.push(`/banner/edit/${payload.id}`);
            });
          break;
        case "admin":
          console.log("check admin");
          await api
            .getAdmin_byid(payload.id)
            .then(res => {
              console.log(res.data.data);
              commit("Get_Editdata", res.data.data);
            })
            .then(() => {
              router.push(`/administrator/edit/${payload.id}`);
            });
          break;
        case "course":
          console.log("course", payload);
          await api
            .getcourse_byid(payload.id)
            .then(res => {
              console.log(res.data.data);
              commit("Get_Editdata", res.data.data);
            })
            .then(() => {
              router.push(`/course/edit/${payload.id}`);
            });
          break;
        case "video":
          console.log("video", payload);
          await api
            .getvideo_byid(payload.id)
            .then(res => {
              commit("Get_Editdata", res.data);
            })
            .then(() => {
              router.push(`/video/edit/${payload.id}`);
            });
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  },

  async push_pointer({ commit }, payload) {
    console.log("pointer :", payload);
    try {
      await commit("PUSH_POINTER", payload);
    } catch (error) {
      console.log(error);
    }
  },

  async get_LecturerTable({ commit }, payload) {
    try {
      let table = await api.getLecturerTable();
      console.log("Lecturer detail", table.data.data);
      await commit("GET_PAGE", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
    } catch (error) {
      console.log(error);
    }
  },

  async getLecturerDetail({ commit }, payload) {
    try {
      let table = await api.getlecturer_withtable(payload);
      console.log("Lecturer detail", table.data.data);
      await commit("GET_PAGE", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
    } catch (error) {
      console.log(error);
    }
  },

  async get_bannerTable({ commit }, payload) {
    try {
      let table = await api.getBannerTable();
      console.log("Banner detail", table.data.data);
      await commit("GET_PAGE", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
    } catch (error) {
      console.log(error);
    }
  },

  async get_paymentTable({ commit }, payload) {
    try {
      let table = await api.getPaymentTable();
      await commit("GET_PAGE", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
    } catch (error) {
      console.log(error);
    }
  },

  async getuser_table({ commit }, payload) {
    try {
      let table = await api.getUserTable();
      console.log("check", table.data.data);
      await commit("GET_PAGE", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
    } catch (error) {
      console.log(error);
    }
  },

  async getUserDetail({ commit }, payload) {
    try {
      let table = await api.getuser_withtable(payload);
      console.log("check", table.data.data);
      await commit("GET_PAGE", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
    } catch (error) {
      console.log(error);
    }
  },

  async get_countdown({ commit }, payload) {
    try {
      let data = await api.getCountdown();
      console.log("data>>>", data.data.countdown);
      await commit("GET_COUNTDOWN", data.data.countdown);
    } catch (error) {
      console.log(error);
    }
  },

  async get_AdminTable({ commit }, payload) {
    try {
      let table = await api.getAdminTable();
      console.log(table);
      await commit("GET_PAGE", table.data.data);
      await commit("GET_TAB", table.data.data.table.tab);
    } catch (error) {
      console.log(error);
    }
  },

  async get_userInfo({ commit }, payload) {
    try {
      await commit("COLLECT_TOKEN", {
        token: payload.token,
        refresh_token: payload.RefreshToken
      });
      await commit("GET_ADMIN_INFO", payload.data);
    } catch (error) {
      console.log(error);
    }
  }
};
